import { CONCEPTS } from "./concepts.js";
export const STOPWORDS = new Set(`a an the and or but if then than that this these those of for from with without to in on at by as is are was
   were be been being am do does did doing have has had having i me my we our you your he she it they them their
   someone anyone some any all more most other another such no nor not only own same so too very can will just
   should now here there when where who whom which what how why looking look need needs needed want wants wanted
   seeking seek help helping please recommend recommendation recommendations referral referrals know knows good
   great best trying try get getting find finding hire hiring available service services offer offers offering
   provide provides providing professional experienced quality affordable local area near about also would could
   like into over out up down`
    .split(/\s+/)
    .filter(Boolean));
/** Lowercase, strip accents and punctuation, collapse whitespace. */
export function normalizeText(text) {
    if (!text)
        return "";
    return text
        .normalize("NFKD")
        .replace(/\p{M}+/gu, "")
        .toLowerCase()
        .replace(/[^a-z0-9\s]+/g, " ")
        .replace(/\s+/g, " ")
        .trim();
}
/** Crude singularisation: enough to make "pipes" and "pipe" agree without a stemmer. */
export function singularize(token) {
    if (token.length <= 3)
        return token;
    if (token.endsWith("ies"))
        return token.slice(0, -3) + "y";
    if (token.endsWith("sses"))
        return token.slice(0, -2);
    if (/(xes|ches|shes)$/.test(token))
        return token.slice(0, -2);
    if (token.endsWith("ss") || token.endsWith("us"))
        return token;
    if (token.endsWith("s"))
        return token.slice(0, -1);
    return token;
}
/**
 * Normalised, de-stopworded, singularised tokens (duplicates kept, in order).
 * Single characters and pure digits never distinguish one service from another and only inflate overlap.
 */
export function tokens(text) {
    const out = [];
    for (const raw of normalizeText(text).split(" ")) {
        if (raw.length < 2 || /^\d+$/.test(raw))
            continue;
        const token = singularize(raw);
        if (token.length < 2 || STOPWORDS.has(token) || STOPWORDS.has(raw))
            continue;
        out.push(token);
    }
    return out;
}
// Inverted index: surface term (raw and singular) -> concepts.
const TERM_TO_CONCEPTS = new Map();
for (const [concept, terms] of Object.entries(CONCEPTS)) {
    for (const term of terms) {
        for (const form of new Set([term, singularize(term)])) {
            let set = TERM_TO_CONCEPTS.get(form);
            if (!set)
                TERM_TO_CONCEPTS.set(form, (set = new Set()));
            set.add(concept);
        }
    }
}
/** Domain concepts implied by a token list, sorted for stable output. */
export function conceptsFor(tokenList) {
    const found = new Set();
    for (const token of tokenList) {
        const hits = TERM_TO_CONCEPTS.get(token);
        if (hits)
            for (const c of hits)
                found.add(c);
    }
    return [...found].sort();
}
/** Whether a token is a known concept term (used by the keyword extractor to rank domain words higher). */
export function isConceptTerm(token) {
    return TERM_TO_CONCEPTS.has(token);
}
/** The unit the scorer compares: tokens catch what the concept map does not know, concepts catch synonyms. */
export function tokenize(text) {
    const list = tokens(text);
    return { tokens: list, concepts: conceptsFor(list) };
}
//# sourceMappingURL=normalize.js.map